import BlockImage from './block-image';

export default class BlockImageDesktop extends BlockImage {
    constructor(...args) {
        super(...args);
    }

    /*
    init() {
    }
    bind() {
    }
    unbind() {
    }
    resize(width, height) {
    }
    */
}



// WEBPACK FOOTER //
// ./src/js/components/block-image/block-image.desktop.js